export default __webpack_public_path__ + "guide-close7bf9fb.png";